// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__UPl1K","df":"Sidebar_df__nrxfA"};